import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap'; // Adjust based on your actual Modal component
import PhoneInput from 'react-phone-input-2'; // Assumes you're using react-phone-input-2
import 'react-phone-input-2/lib/style.css';
import { getUserDetailsById } from '../../api/customer/master/userMasterApi';
import { useInstance } from '../../context/instance.context';
import { getAllShippingAddressByUserId, getCountry } from '../../api/customer/masters/commonMastersApi';

const GenericAddressComponent = ({
    show,
    setShow,
    type = 'shipping',
    onAddFunction,
    onUpdateFunction,
    editAddressId,
    getAddressById,
    userId,
    userFirstName,
    userLastName,
    userAllShippingAddress,
    isAdmin,
}) => {
    //log all the prop
    const [userShippingAddress, setUserShippingAddress] = useState([]);



    useEffect(() => {
        if (!show) return;
        (async () => {
            try {
                const { country } = await getCountry();
                console.log("Comming Country :", country);
                setUserCountry(country);

            } catch (error) {
                console.log("Error while fetching country :", error);
            }
        })()

    }, [show]);


    const [showCopyModal, setShowCopyModal] = useState(false);


    useEffect(() => {
        (async () => {
            if (userId) {

                const response = await getAllShippingAddressByUserId(userId);
                if (response.success) {
                    const { data } = response;
                    setUserShippingAddress(data);
                };

            } else {
                setUserShippingAddress(userAllShippingAddress || []);
            }
        })()

    }, [userId, show]);






    const [formDataValidation, setFormValidation] = useState(false);
    const [userCountry, setUserCountry] = useState('');
    console.log("Country :", userCountry);
    const { name, allInstanceData } = useInstance();
    const is8xParts = allInstanceData?._8xPart == name;
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        dialCode: '',
        phoneNo: '',
        addressLineOne: '',
        addressLineTwo: '',
        postalCode: '',
        city: '',
        state: '',
        country: is8xParts ? "US" : "Ireland",
    });
    useEffect(() => {
        if (show) setFormValidation(false);
        const fetchData = async () => {
            try {
                // Case 1: Adding new address (show is true, not editing)
                if (show && !editAddressId) {
                    // Clear form fields for new address
                    setFormData({
                        firstName: userFirstName || '',
                        lastName: userLastName || '',
                        dialCode: '',
                        phoneNo: '',
                        addressLineOne: '',
                        addressLineTwo: '',
                        postalCode: '',
                        city: '',
                        state: '',
                        country: is8xParts ? "US" : "Ireland",
                    });

                    // Fetch user details if userId is provided
                    if (userId) {
                        const response = await getUserDetailsById(userId);
                        if (!response.success) {
                            throw new Error("Failed to fetch user details");
                        }
                        const { data } = response;
                        setFormData((prev) => ({
                            ...prev,
                            firstName: data.firstName || "",
                            lastName: data.lastName || "",
                            phoneNo: data.phoneNumber || "",
                            dialCode: data.dialCode || "",
                        }));
                    }
                }

                // Case 2: Editing existing address
                if (show && editAddressId && typeof getAddressById === 'function') {
                    const data = await getAddressById(editAddressId);
                    if (data) {
                        console.log("Getting Data:", data);

                        setFormData({
                            firstName: data.firstName || '',
                            lastName: data.lastName || '',
                            dialCode: data.dialCode?.toString() || '',
                            phoneNo: data.phoneNo?.toString().replace(data.dialCode, '') || '',
                            addressLineOne: data.addressLineOne || '',
                            addressLineTwo: data.addressLineTwo || '',
                            postalCode: data.postalCode || '',
                            city: data.city || '',
                            state: data.state || '',
                            country: data.country || '',
                        });
                    }
                }

            } catch (error) {
                console.error("Error in useEffect logic:", error);
            }
        };

        fetchData();
    }, [show, userId, editAddressId, getAddressById]);






    const onChangeHandler = (e, field) => {
        setFormData({
            ...formData,
            [field]: e.target.value,
        });
    };

    const onPhoneChange = (value, country) => {
        const dial = country.dialCode;
        setFormData({
            ...formData,
            dialCode: dial,
            phoneNo: value.slice(country.dialCode.length, value.length),
        });
    };

    const isFormInvalid = () => {
        setFormValidation(true);
        const required = ['firstName', 'lastName', 'addressLineOne', 'city', 'country'];
        return required.some((field) => formData[field].trim() === '');
    };

    const saveData = () => {
        setFormValidation(false);
        if (isFormInvalid()) return;

        const payload = {
            ...formData,
        };

        if (editAddressId) {
            onUpdateFunction(editAddressId, payload);
        } else {
            onAddFunction(payload);
        }

        setShow(false);
    };

    console.log("Form Data :", formData);

    const handleCopyClicked = (data) => {
        setFormData({
            firstName: data.firstName || '',
            lastName: data.lastName || '',
            dialCode: data.dialCode?.toString() || '',
            phoneNo: data.phoneNo?.toString().replace(data.dialCode, '') || '',
            addressLineOne: data.addressLineOne || '',
            addressLineTwo: data.addressLineTwo || '',
            postalCode: data.postalCode || '',
            city: data.city || '',
            state: data.state || '',
            country: data.country || '',
        });
        setShowCopyModal(false);
    }


    const {
        firstName,
        lastName,
        dialCode,
        phoneNo,
        addressLineOne,
        addressLineTwo,
        postalCode,
        city,
        state,
        country,
    } = formData;

    return (
        <div>
            <Modal show={show} onHide={() => setShow(false)} showClose centered>
                <Modal.Header closeButton>
                    <div className="title" style={{ fontSize: '25px', fontWeight: 'bold', marginLeft: '10px' }}>
                        {editAddressId ? 'Update Address' : `Add new ${type} address`}
                    </div>
                </Modal.Header>

                <div className="addressModal m-0 p-0">
                    <div className="straightLine" />
                    <div className="addressContainer !my-0">
                        <div className="name">
                            <div className="first">
                                <p>First Name</p>
                                <input
                                    type="text"
                                    value={firstName}
                                    className="form-input px-2 my-1"
                                    style={{ border: formDataValidation && firstName === '' ? '1px solid red' : '' }}
                                    onChange={(e) => onChangeHandler(e, 'firstName')}
                                />
                                <div className="errorMessage">
                                    {formDataValidation && firstName === '' && 'First Name cannot be empty'}
                                </div>
                            </div>
                            <div className="last">
                                <p>Last Name</p>
                                <input
                                    type="text"
                                    value={lastName}
                                    className="form-input px-2 my-1"
                                    style={{ border: formDataValidation && lastName === '' ? '1px solid red' : '' }}
                                    onChange={(e) => onChangeHandler(e, 'lastName')}
                                />
                                <div className="errorMessage">
                                    {formDataValidation && lastName === '' && 'Last Name cannot be empty'}
                                </div>
                            </div>
                            <div className="number">
                                <p>Mobile Number</p>
                                <PhoneInput
                                    country={userCountry?.toLowerCase()}
                                    className="form-input px-2 my-1"
                                    value={`${dialCode?.toString() + phoneNo.toString()}`}
                                    onChange={onPhoneChange}
                                />
                                <div className="errorMessage">
                                    {formDataValidation && phoneNo === '' && 'Phone number cannot be empty'}
                                </div>
                            </div>
                        </div>

                        <div className="address1">
                            <p>Address Line 1</p>
                            <input
                                type="text"
                                value={addressLineOne}
                                className="form-input px-2 my-1"
                                style={{ border: formDataValidation && addressLineOne === '' ? '1px solid red' : '' }}
                                onChange={(e) => onChangeHandler(e, 'addressLineOne')}
                            />
                            <div className="errorMessage">
                                {formDataValidation && addressLineOne === '' && 'Address1 cannot be empty'}
                            </div>
                        </div>

                        <div className="address2">
                            <p>Address Line 2</p>
                            <input
                                type="text"
                                value={addressLineTwo}
                                className="form-input px-2 my-1"
                                onChange={(e) => onChangeHandler(e, 'addressLineTwo')}
                            />
                        </div>

                        <div className="grid grid-col-3 gap-x-2">
                            <div className="city">
                                <p>City</p>
                                <input
                                    type="text"
                                    value={city}
                                    className="form-input px-2 my-1"
                                    style={{ border: formDataValidation && city === '' ? '1px solid red' : '' }}
                                    onChange={(e) => onChangeHandler(e, 'city')}
                                />
                                <div className="errorMessage">
                                    {formDataValidation && city === '' && 'City cannot be empty'}
                                </div>
                            </div>

                            <div className="state">
                                <p>State/Province</p>
                                <input
                                    type="text"
                                    value={state}
                                    className="form-input px-2 my-1"
                                    onChange={(e) => onChangeHandler(e, 'state')}
                                />
                            </div>

                            <div className="zip">
                                <p>Zip/Postal Code</p>
                                <input
                                    type="text"
                                    value={postalCode}
                                    className="form-input px-2 my-1"
                                    onChange={(e) => onChangeHandler(e, 'postalCode')}
                                />
                            </div>

                            <div className="country col-span-3">
                                <p>Country</p>
                                <input
                                    type="text"
                                    value={country}
                                    className="form-input px-2 my-1"
                                    style={{ border: formDataValidation && country === '' ? '1px solid red' : '' }}
                                    onChange={(e) => onChangeHandler(e, 'country')}
                                />
                                <div className="errorMessage">
                                    {formDataValidation && country === '' && 'Country cannot be empty'}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-end'>
                        {type == 'billing' ?<div className="buttons">
                            <button className="primary-btn" onClick={() => setShowCopyModal(true)} >
                                Copy shipping address
                            </button>
                        </div> : null}
                        <div className="buttons">
                            <button className="primary-btn" onClick={saveData}>
                                {editAddressId ? 'Update' : 'Add'}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal show={showCopyModal} onHide={() => setShowCopyModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Select Shipping Addresses</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className=" !h-[420px] overflow-y-scroll  m-0 p-0">
                        {userShippingAddress.map((address) => (
                            <div
                                key={address.id}
                                className="p-3 border mb-2 rounded flex items-center justify-between  gap-3 cursor-pointer "
                            >

                                <div>
                                    <p className='font-semibold text-sm'><strong>{address.firstName} {address.lastName}</strong></p>
                                    <p className=' text-sm'>{address.addressLineOne}, {address.addressLineTwo}</p>
                                    <p className=' text-sm'>{address.city}, {address.state}, {address.postalCode}</p>
                                    <p className=' text-sm'>{address.country}</p>
                                </div>
                                <div className='px-2 py-2 mx-2 bg-primaryColor text-sm text-white rounded' onClick={() => handleCopyClicked(address)}>Select </div>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <button className="secondary-btn" onClick={() => setShowCopyModal(false)}>Cancel</button> */}
                    {/* <button className="primary-btn" onClick={copySelectedAddresses}>OK</button> */}
                </Modal.Footer>
            </Modal>
        </div>

    );
};

export default GenericAddressComponent;
